/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
/**
 * Program: Router
 * Author: SDL
 * Description: router setting file
 */
import Vue from 'vue';
import Router from 'vue-router';
import _ from 'lodash';
import axios from 'axios';
import store from '@/vuex/store';
import { fetchMenuAll } from '@/service/menuService';
import SDLUtil from '@/utils/SDLUtil';

import { i18n, loadLanguageAsync } from '../i18n';
// 일반
import LoginPage from '@/components/view/admin/main/LoginPage';
import MainPage from '@/components/view/admin/main/MainPage';
import MainIndexPage from '@/components/view/admin/main/MainIndexPage';
import EmptyPage from '@/components/view/admin/main/EmptyPage';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    // login
    {
      name: 'login',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/login`,
      component: LoginPage,
    },
    // logout
    {
      name: 'logout',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/logout`,
      component: () => import(/* webpackChunkName: '[request]' */ '@/components/view/admin/main/LoginOut'),
    },
    // system registration
    {
      name: 'systemUserRegister',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/register`,
      component: () => import(/* webpackChunkName: '[request]' */ '@/components/view/admin/main/RegisterPage'),
    },
    // system subscription clause
    {
      name: 'terms',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/terms-conditions`,
      component: () => import(/* webpackChunkName: '[request]' */ '@/components/view/admin/main/TermsAndConditionsPage'),
    },
    // Password initialization
    {
      name: 'initPassword',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/initPassword`,
      component: () => import(/* webpackChunkName: '[request]' */ '@/components/view/admin/main/InitPassword'),
    },
    // sample test
    {
      path: `${SDLUtil.WEB_CONTEXT_PATH}/sample/tree`,
      component: () => import('@/components/view/sample/Tree'),
    },
    {
      path: `${SDLUtil.WEB_CONTEXT_PATH}/sample/fileuploader`,
      component: () => import('@/components/view/sample/FileUploader'),
    },
    {
      path: `${SDLUtil.WEB_CONTEXT_PATH}/sample/tabs`,
      component: () => import('@/components/view/sample/Tabs'),
    },
    {
      path: `${SDLUtil.WEB_CONTEXT_PATH}/sample/excel`,
      component: () => import('@/components/view/sample/Excel'),
    },
    {
      path: `${SDLUtil.WEB_CONTEXT_PATH}/sample/regexinput`,
      component: () => import('@/components/view/sample/RegexInput'),
    },
    // popup
    {
      name: 'noticePopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/noticePopup/:boardId/:postId`,
      component: () => import(/* webpackChunkName: '[request]' */ '@/components/view/admin/board/PostPopup'),
    },
    // popup
    {
      name: 'transPopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/transPopup`,
      component: () => import('@/components/view/admin/main/TransPopup'),
    },
    // No page registration in menu management => Unconditional 404 processing of user criteria regardless of component registration
    {
      name: 'emptyPage',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/emptypage`,
      component: EmptyPage,
    },
    {
      name: '404',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/404`,
      component: EmptyPage,
    },
    {
      name: 'error',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/error`,
      component: EmptyPage,
    },
    // Page if not authenticated
    {
      path: `${SDLUtil.WEB_CONTEXT_PATH}/noauth`,
      component: () => import(/* webpackChunkName: 'no_auth' */ '@/components/view/admin/main/NoAuthPage'),
    },
    {
      name: 'main',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/`,
      alias: '/',
      component: MainPage,
      children: [
        {
          name: 'mainIndexPage',
          path: '',
          component: MainIndexPage,
        },
      ], // mock
    },
    // otherwise redirect to home
    {
      path: '*',
      redirect: `${SDLUtil.WEB_CONTEXT_PATH}/404`,
    },
    {
      path: `${SDLUtil.WEB_CONTEXT_PATH}/planDetail/:planId/:bizDivisCd/:planNm`,
      component: () => import('@/components/view/smip/mem/mdp/UI-DSI2303-008-00002_Detail'),
    },    
    // MDP Window Popup UI-DSI2303-008-00003
    {
      name: 'PlanDataWinPopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/planDataWinPopup/:planId/:bizDivisCd/:caseId/:gfam1Id/:templateId/:templateVerNo/:dataId/:inputSectnType/:planNm/:caseIdNm/:bizDivisNm/:deplType/:closeYn/:excReaContNm/:dataStart/:dataEnd`,
      component: () => import('@/components/view/smip/mem/mdp/UI-DSI2303-008-00003'),
    },
    {
      name: 'PlanDataTempPopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/planDataTempPopup`,
      component: () => import('@/components/view/ux/template/UI-DSI2303-008-00003'),
    },
    // LSI Window Popup UI-DSI2303-008-00011
    {
      name: 'LsiPlanDataWinPopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/lsiPlanDataWinPopup`,
      component: () => import('@/components/view/ux/template/UI-DSI2303-008-00012_P1'),
    },   
    {
      name: 'LsiSetTAMWinPopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/lsiSetTAMWinPopup`,
      component: () => import('@/components/view/ux/template/UI-DSI2303-008-00010_P1'),
    },
    {
      path: `${SDLUtil.WEB_CONTEXT_PATH}/smip/lsi/ypt/planData/:planId`,
      component: () => import('@/components/view/smip/lsi/ypt/popup/UI-DSI2303-008-00012_P1'),
    },
    //Set TAM 데이터 입력기 팝업
    {
      name: 'SetTamPopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/smip/lsi/stm/popup/:planId/:tmplId/:planNm/:tmplNm/:tmplVer/:settItem/:settItemNm/:tmplSheetNm/:inputId/:inputNm/:inputType/:inputHeader/:inputCount/:year/:month/:status`,
      component: () => import('@/components/view/smip/lsi/stm/popup/UI-DSI2303-008-00010_P2'),
    },    
    {
      name: 'RulePopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/smip/mem/eda/RulePopup`,
      component: () => import('@/components/view/smip/mem/eda/UI-DSI2303-008-00036_P2'),
    },
    {
      name: 'LsiRulePopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/smip/lsi/eda/LsiRulePopup`,
      component: () => import('@/components/view/smip/lsi/eda/UI-DSI2303-008-00047_P2'),
    },
    {
      name: 'StmRulePopup',
      path: `${SDLUtil.WEB_CONTEXT_PATH}/smip/lsi/stm/StmRulePopup`,
      component: () => import('@/components/view/smip/lsi/stm/popup/UI-DSI2303-008-00050_P2'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/logout', '/register', '/initPassword', '/error'].map(
    page => SDLUtil.WEB_CONTEXT_PATH + page,
  );
  const authRequired = !publicPages.includes(to.path);
  // const loggedIn = SDLUtil.isLogin();
  var loggedIn = SDLUtil.isLogin();
  console.log('publicPages::: ', publicPages);
  console.log('to.path::: ', to.path);
  console.log('authRequered::: ', authRequired);
  console.log('loggedIn::: ', loggedIn);
  if (loggedIn){
      try {
        const decodeuserid = localStorage.getItem('encodeUserID');
        const userid = JSON.parse(localStorage.getItem('user')).sub;
        let urlUserID = new URLSearchParams(window.location.search).get('e');
        if (!urlUserID){
          try{
            urlUserID = new URLSearchParams(new URLSearchParams(window.location.search).get('redirect').split('?')[1]).get('e').replace(' ', '+');  
          }catch(e) {
            urlUserID = userid;
          }
        } 
        if(decodeuserid!== urlUserID.replace(' ', '+') && userid !== urlUserID.replace(' ', '+')){
          localStorage.setItem('user', '');
          localStorage.setItem('userToken', '');
          localStorage.setItem('encodeUserID', '');
          loggedIn = SDLUtil.isLogin();
        }
      } catch (e) {
        localStorage.setItem('user', '');
        localStorage.setItem('userToken', '');
        localStorage.setItem('encodeUserID', '');
        loggedIn = SDLUtil.isLogin();
      }
  }
  if (authRequired && !loggedIn ) {
    if (to.fullPath.indexOf(`${SDLUtil.WEB_CONTEXT_PATH}/404`) > -1 || to.fullPath === `${SDLUtil.WEB_CONTEXT_PATH}/`) {
      return next(`${SDLUtil.WEB_CONTEXT_PATH}/login`);
    }
    if (to.fullPath.indexOf(`${SDLUtil.WEB_CONTEXT_PATH}/noauth`) > -1) {
      return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/login`, query: { redirect: to.redirectedFrom } });
    }
    return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/login`, query: { redirect: to.fullPath } });
  } else if ( to.path == '/error' && !loggedIn ){
    return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/login`, query: { redirect: to.fullPath } });
  }
  return next();
});

router.beforeEach((to, from, next) => {
  // Import locale information from logged in user information
  let userPreferLang;
  const userInfo = SDLUtil.getLoginedUserInfo();
  if (userInfo && userInfo.language) {
    userPreferLang = userInfo.language;
  }

  console.log('router Index.js Language');
  console.log(SDLUtil.DEFAULT_LANG);
  console.log(userPreferLang);
  console.log(window.navigator.userLanguage);
  console.log(window.navigator.language);

  const lang = (SDLUtil.DEFAULT_LANG || userPreferLang || window.navigator.language || window.navigator.userLanguage).replace(
    '-',
    '_',
  );
  loadLanguageAsync(lang).then(() => next());
});

// Add to menu ID, page ID header when changing router
router.beforeEach((to, from, next) => {
  if (to.meta.menuId) {
    axios.defaults.headers.common['menu-id'] = to.meta.menuId;
  } else {
    delete axios.defaults.headers.common['menu-id'];
  }
  if (to.meta.pageId) {
    axios.defaults.headers.common['page-id'] = to.meta.pageId;
  } else {
    delete axios.defaults.headers.common['page-id'];
  }

  return next();
});

// Language Settings When Changing Router
router.beforeEach((to, from, next) => {
  console.log('router getLocale');
  console.log(store.getters.getLocale);
  console.log(i18n.locale);
  if (store.getters.getLocale !== '') {
    i18n.locale = store.getters.getLocale;
  }
  return next();
});

// Initialize storing the stored parameter setting value when changing the router
router.beforeEach((to, from, next) => {
  if (to.params.restoreList !== true && to.meta.menuId !== from.meta.menuId) {
    store.commit('PARAMS', {});
  }
  // console.info('파라미터값', store.getters.getParams, to.params.restoreList);
  return next();
});

router.afterEach(to => {
  let title = SDLUtil.getMsgProp('sdl.common.projectName');
  if (to.meta.labelJson && to.meta.labelJson[i18n.locale]) {
    title += ` - ${to.meta.labelJson[i18n.locale]}`;
  } else if (to.meta.label) {
    title += ` - ${to.meta.label}`;
  }
  document.title = title;
  if (to.meta.menuId !== undefined) {
    axios.post(`${SDLUtil.API_URL}/history/menuUseHistory/${to.meta.menuId}`).then();
  }
});

export async function addEntryPoint(routeData = []) {
  const entryChildren = routeData
    .filter(menu => menu.pagePath)
    .map(menu => ({
      name: menu.pageId,
      path: menu.pagePath,
      redirect: `${SDLUtil.WEB_CONTEXT_PATH}/noauth`,
      meta: {
        ...menu,
      },
    }));
  const { routes } = router.options;
  const mainRoute = routes.find(r => r.name === 'main');

  // const existComponents = componentList.map(r => r.path);

  // If you are logged in
  if (SDLUtil.isLogin()) {
    // Import common code
    // await SDLUtil.loadAllCommCodeList();
    // await store.dispatch('getMenus');
    const termsUrl = `${SDLUtil.WEB_CONTEXT_PATH}/terms-conditions`;
    const isTermsPage = window.location.pathname === termsUrl;
    const menuResponse = await fetchMenuAll()
      .then(res => res)
      .catch(err => {
        // We need agreement.
        if (err.data.error.code === 201 && !isTermsPage) {
          console.info('change', err);
          window.location.href = termsUrl;
        }
      });

    // skip the terms and conditions page
    if (isTermsPage) {
      return;
    }

    await Promise.all([SDLUtil.loadAllCommCodeList(), store.dispatch('getMenus')]);

    let authPages = [];
    if (menuResponse){
      menuResponse.data.forEach(menu => {
        const pages = menu.pages.map(page => {
          const routeItem = {
            name: page.pageId,
            path: page.pagePath,
            component: EmptyPage,
            meta: {
              ...menu,
              ...page,
            },
          };
          if (page.componentName !== undefined && page.componentName !== '') {
            routeItem.component = () => import(/* webpackChunkName: '[request]' */ `@/components/view/${page.componentName}`);
          }
          return routeItem;
        });
  
        authPages = authPages.concat(pages);
      });
    }

    authPages.forEach(page => {
      const idx = _.findIndex(entryChildren, ['path', page.path]);
      if (idx > -1) {
        entryChildren[idx] = page;
      }
    });
  }

  mainRoute.children = [...entryChildren];

  router.addRoutes([mainRoute]);
}

router.onError(error => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js